export default {
    // BACKEND_URL : 'https://timetable-backend.vercel.app'
    BACKEND_URL : 'https://timetable-final.vercel.app'
}